const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20film%20scene%2C%20grand%20battle%20with%20golden%20armor%2C%20ancient%20Chinese%20palace%20background%2C%20cinematic%20epic%20lighting%2C%20dramatic%20clouds%2C%20warm%20golden%20and%20crimson%20tones%2C%20movie%20poster%20quality&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '焦点专题',
    title: '封神宇宙：国产神话电影工业的崛起之路',
    desc: '从《封神第一部》到即将上映的第三部，深度解析中国神话电影如何构建属于自己的电影宇宙。',
    meta: '深度报道 · 15分钟阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20working%20with%20actors%20on%20set%2C%20intimate%20behind%20the%20scenes%2C%20camera%20crew%2C%20professional%20lighting%20setup%2C%20warm%20cinematic%20atmosphere%2C%20documentary%20style%20photography&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '幕后揭秘',
    title: '王家卫的8年：一部电影的诞生全记录',
    desc: '从概念手稿到最终成片，独家揭秘大师级导演的创作方法论与不为人知的片场故事。',
    meta: '独家专访 · 22分钟阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=International%20film%20festival%20red%20carpet%2C%20celebrities%20posing%2C%20elegant%20evening%20attire%2C%20golden%20award%20statue%2C%20prestigious%20event%2C%20glamorous%20atmosphere%2C%20editorial%20fashion%20photography&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '独家追踪',
    title: '华语片征战国际电影节：从入围到获奖的完整时间线',
    desc: '2026年度三大国际电影节华语力量全景扫描，入围作品、获奖概率与幕后博弈。',
    meta: '专题策划 · 18分钟阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Movie%20box%20office%20data%20visualization%2C%20digital%20dashboard%20with%20charts%2C%20luxurious%20dark%20theme%2C%20golden%20numbers%2C%20financial%20analysis%20aesthetic%2C%20corporate%20style&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '票房黑马',
    title: '2026暑期档票房全景复盘：谁是真正的赢家？',
    desc: '用数据说话，逐片分析暑期档70余部新片的市场表现，揭秘票房背后的宣发博弈。',
    meta: '数据分析 · 12分钟阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20news%20coverage%2C%20dramatic%20press%20conference%2C%20microphones%2C%20intense%20facial%20expressions%2C%20paparazzi%20photography%20style%2C%20high%20contrast%20lighting%2C%20cinematic%20noir&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '争议事件',
    title: '2026影视圈十大争议事件全盘点',
    desc: '从演员片酬风波到导演创作自由之争，回顾本年度最具话题性的行业争议。',
    meta: '年度盘点 · 25分钟阅读',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animation%20studio%20artists%20working%2C%20creative%20workspace%2C%20concept%20art%20on%20walls%2C%20colorful%20sketches%2C%20warm%20creative%20atmosphere%2C%20Chinese%20animation%20style%2C%20documentary%20photography&width=1200&height=600&seq=carousel-06&orientation=landscape',
    tag: '明星动态',
    title: '国产动画新势力：10位你必须认识的动画导演',
    desc: '从《哪吒》到《长安三万里》，新一代动画导演正在重塑中国动画电影版图。',
    meta: '人物特写 · 20分钟阅读',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="bg-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-4">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
            编辑精选深度专题报道，聚焦影视圈最值得关注的故事
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item, i) => (
              <article
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={i > 2 ? 'lazy' : undefined}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-3 py-1 rounded-full bg-primary-500 text-white text-xs font-semibold">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-4 flex-1">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-2 text-xs text-foreground-400">
                    <i className="ri-time-line"></i>
                    <span>{item.meta}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}